import React from "react";
import { callApi } from "../../utils/api";
import { Sro } from "./ManageSro";

interface AllProps {
  selectedSro: Sro;
  listSro: any;
  path?: any;
}
class AddSro extends React.Component<AllProps> {
  state = {
    srodetail: { sro_id: 0, sro: "" }
  };
  componentWillReceiveProps(nextState) {
    if (nextState.path == "managementsro") {
      const srodetail = nextState.selectedSro;
      srodetail.sro = srodetail.name;
      srodetail.sro_id = srodetail.id;
      delete srodetail.name;
      this.setState({ srodetail });
    }
  }
  handleChange = (e: any) => {
    const srodetail: any = this.state.srodetail;
    srodetail[e.target.name] = e.target.value;
    this.setState({ srodetail });
  };
  saveSro = () => {
    if (this.state.srodetail.sro_id) {
      this.state.srodetail.sro_id = Number(this.state.srodetail.sro_id);
    }
    callApi("POST", "sro.php", this.state.srodetail)
      .then(res => res.data)
      .then(response => {
        this.props.listSro();
      })
      .catch(err => {
        console.log(err);
      });
  };
  render() {
    return (
      <div
        className="modal fade"
        id="sro-form"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">SRO Form</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="form-group">
                  <label className="col-form-label">SRO Name:</label>{" "}
                  <input
                    type="text"
                    name="sro"
                    className="form-control"
                    placeholder="Sro Name"
                    onChange={e => {
                      this.handleChange(e);
                    }}
                    value={
                      this.state.srodetail.sro ? this.state.srodetail.sro : ""
                    }
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={this.saveSro}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddSro;
